<template>
  <div class="auctionSuccess ant-layout">

    <h2 class="intro-y text-lg font-medium mt-10">一键转至360pai进行租赁权招商</h2>
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div
          class="intro-y col-span-12 flex flex-wrap sm:flex-no-wrap items-center mt-2"
      >
        <button class="button text-white bg-theme-1 shadow-md mr-2"
                @click='$router.push({path:"/assetManagement/assetDetail",query:{ assetId :  form.assetId}})'>
          返回
        </button>
      </div>
    </div>
    <div class="intro-y box py-10 sm:py-20 mt-5">
      <div
          class="wizard flex flex-col lg:flex-row justify-center px-5 sm:px-20"
      >
        <div
            class="intro-x lg:text-center flex items-center lg:block flex-1 z-10"
        >
          <button class="w-10 h-10 rounded-full button text-gray-600 bg-gray-200 dark:bg-dark-1">
            1
          </button>
          <div class="lg:w-32 font-medium text-base lg:mt-3 ml-3 lg:mx-auto">
            生成招商公告
          </div>
        </div>

        <div
            class="intro-x lg:text-center flex items-center mt-5 lg:mt-0 lg:block flex-1 z-10"
        >
          <button
              class="w-10 h-10 rounded-full button text-gray-600 bg-gray-200 dark:bg-dark-1"
          >
            2
          </button>
          <div
              class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto text-gray-700 dark:text-gray-600"
          >
            填写拍卖信息
          </div>
        </div>
        <div
            class="intro-x lg:text-center flex items-center mt-5 lg:mt-0 lg:block flex-1 z-10"
        >
          <button
              class="w-10 h-10 rounded-full button text-white bg-theme-1"


          >
            3
          </button>
          <div
              class="lg:w-32 text-base lg:mt-3 ml-3 lg:mx-auto text-gray-700 dark:text-gray-600"
          >
            完成
          </div>
        </div>
        <div
            class="wizard__line hidden lg:block w-1/2 bg-gray-200 dark:bg-dark-1 absolute mt-5"
        ></div>
      </div>
      <div
          style='margin-top: 12px;padding: 48px 32px;text-align:center;'
      >
        <div style='color: #52c41a;font-size: 72px; text-align:center;'>
          <svg viewBox="64 64 896 896" data-icon="check-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class="" style='display: inline-block'><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"></path></svg>
        </div>

        <div  class='title'>
          已在360pai上传成功
        </div>
        <div class='subTitle'>
          <div>
            <span>资产名称：{{baseInfo.certificateAddress}}</span>-{{baseInfo.managementEnterprise}}
          </div>
          <div style='margin-top: 15px;'>
            <span>资产编号： </span>{{baseInfo.assetNumber}}
            <span style='margin-left: 30px;'>负责人： </span>张小丽
          </div>
        </div>
        <template>
          <el-button key="console" type="primary" style='margin-top: 70px;' @click="go360pai">
            前往360pai个人中心查看
          </el-button>
          <el-button key="buy" @click='back'>
            返 回
          </el-button>
        </template>
      </div>

    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: "auctionSuccess",
  components: {},
  data() {
    return {
      assetId:'',
    }
  },
  methods: {
    back(){
      this.$router.push({path: '/assetManagement/assetDetail',query:{ assetId : this.assetId, status:"success",} })
    },
    go360pai(){
      window.open('https://www.360pai.com/member')
    },
  },
  created() {
    this.assetId=this.$route.query.assetId
  },
  computed: {
    ...mapState({
      baseInfo:state=>state.auction.baseInfo
    })
  },
}
</script>

<style scoped lang="scss">
.auctionSuccess {
  height: calc(100vh - 64px);

  .header {
    font-size: 20px;
    font-weight: 700;
    padding: 30px;
    background: #fff;
    border-top: 2px solid #f0f2f5;
  }


  .title{
    font-size: 24px;
    font-weight: 700;
    margin-bottom:40px;
    padding-top: 14px;
  }
  .subTitle{
    color: #000;
    font-size: 14px;

    span{
      font-weight: 700;
      font-size: 18px;
    }

  }

}
</style>
